import React, { useEffect } from 'react';

const NotificationListeners = ({ eventEmitter, applyStoreAction }) => {
    const listen = () => {
        eventEmitter.on('new_notification', notification => {
            applyStoreAction({
                type: 'NOTIFICATION_ADD_SOCKET',
                payload: { notification }
            });
        });

        eventEmitter.on('notification_read', ({ ids: notificationIds }) => {
            applyStoreAction({
                type: 'NOTIFICATIONS_READ_SOCKET',
                payload: { notificationIds }
            });
        });

        eventEmitter.on('notification_update', notification => {
            applyStoreAction({
                type: 'NOTIFICATIONS_UPDATE_SOCKET',
                payload: { notification }
            });
        });

        eventEmitter.on('notification_remove', ({ ids: notificationIds }) => {
            applyStoreAction({
                type: 'NOTIFICATIONS_REMOVE_SOCKET',
                payload: { notificationIds }
            });
        });
    }

    useEffect(listen, []);

    return null;
}

export default NotificationListeners;
